import Payment from './payment.vue'

export default Payment
